import React from 'react';
import ViewSearch from '../../core/viewSearch';

export default function VisitationView() {
    const VISITATION_BASE_URL = process.env.REACT_APP_VISITATION_BASE_URL;
    const VISITATION_SEARCH = process.env.REACT_APP_VISITATION_SEARCH;

    const url = VISITATION_BASE_URL + VISITATION_SEARCH;

    return (
        <>
            <span ><b>Visitation View </b> </span>
            <ViewSearch url={url} pagePath={'/visitation'} />
        </>
    );
}